import { render } from "./TheLoaiHinhTruongMamNon.vue?vue&type=template&id=736eea42"
import script from "./TheLoaiHinhTruongMamNon.vue?vue&type=script&lang=js"
export * from "./TheLoaiHinhTruongMamNon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__